import { SelectOption } from "../../../packages/ui/form/select/SelectOption.js";
import { MONTHS } from "../../model/accounting/date/Month.js";
import { getMonthName } from "../../model/accounting/date/getMonthName.js";

export const MONTH_OPTIONS: SelectOption[] = MONTHS.map((month) => ({
  value: month,
  label: getMonthName(month)
}));
